import React from "react";
import "./AlertMessage.scss"; // import the styles

export type AlertType = "success" | "error" | "info" | "warning";

interface AlertMessageProps {
  type?: AlertType;
  message: string;
  onClose?: () => void;
  isMissingData?: boolean;
}

export interface AlertState {
  type: AlertType;
  message: string;
  isMissingData?: boolean;
}

const AlertMessage: React.FC<AlertMessageProps> = ({
  type = "info",
  message,
  onClose,
  isMissingData = false,
}) => {
  const alertClass = isMissingData
    ? "missing-data"
    : type === "error"
    ? "error"
    : type;

  return (
    <div className={`alert-message ${alertClass}`}>
      <span>{message}</span>
      {onClose && (
        <button onClick={onClose} aria-label="Close alert">
          ✖
        </button>
      )}
    </div>
  );
};

export default AlertMessage;
